import { images } from '../../../Constants/ImageUrls';
import AnywhereHorizontalScroll from '../../HelperComponents/AnywhereHorizontalScroll';
import ProductCard from '../../StoreHomePage/ProductCard';
import {
  ShadowSection,
  Subtitle,
  TitleSection,
} from '../RatingandReviews/styled';

export default function index(props) {
  const { data, title, setChangeCartCount, titleLogo, showHeadingWithLogo } =
    props;
  return (
    <ShadowSection padding="12px" newUserbought>
      {showHeadingWithLogo ? (
        <TitleSection>
          <img src={titleLogo} width={100} height={100} alt="" />
          <Subtitle as="div" bigTitle showHeadingWithLogo={showHeadingWithLogo}>
            {' '}
            {title}
          </Subtitle>
        </TitleSection>
      ) : (
        <Subtitle as="div" bigTitle>
          {' '}
          {title}
        </Subtitle>
      )}
      <AnywhereHorizontalScroll
        firstElementId={`0${title}`}
        lastElementId={`${title}last`}
        leftArrow={<img src={images.arrowdownforward} alt="" />}
        rightArrow={<img src={images.arrowdownforward} alt="" />}
        scrolledWidth={440}
      >
        {data?.map((element, index) => (
          <ProductCard
            itemId={`element-${index}`}
            key={`element-${index}`}
            productData={element}
            setChangeCartCount={setChangeCartCount}
            card={element}
            sectionName={element?.id}
            sectionId={element?.id}
            showPrice={true}
            index={index}
            mobileMaxWidth={'210px'}
            mobileMinWidth={'210px'}
            length={data?.length}
            maxWidth={'23%'}
            shrink={'0'}
            storeHome={true}
            title={title}
          />
        ))}
      </AnywhereHorizontalScroll>
    </ShadowSection>
  );
}
